// F1 Circuits Page
import React from 'react';
import { useF1Championship } from '../../hooks/useF1Championship';
import F1PageTemplate from '../../components/f1/F1PageTemplate';
import { circuitsConfig } from '../../components/f1/CircuitsComponent';
import CircuitsComponent from '../../components/f1/CircuitsComponent';

const F1CircuitsPage = () => {
  const { data } = useF1Championship();

  const stats = circuitsConfig.stats.map(stat => ({
    ...stat,
    value: typeof stat.value === 'function' ? stat.value(data) : stat.value
  }));

  return (
    <F1PageTemplate
      title={circuitsConfig.title}
      subtitle={circuitsConfig.subtitle}
      summary={circuitsConfig.summary}
      stats={stats}
    >
      <CircuitsComponent data={data} />
    </F1PageTemplate>
  );
};

export default F1CircuitsPage;
